import React from 'react';
import { Row, Col } from 'antd';

import PeopleKeepLogo from './people-keep-benefits-personalized.svg';

const AccountHeader: React.FC = () => {
  return (
    <Row>
      <Col className="header">
        <a href="#">
          <img src={PeopleKeepLogo} alt="peoplekeep-logo" />
        </a>
      </Col>
    </Row>
  );
};

export default AccountHeader;
